import { Address } from './address';

export enum MedicalType {
  MAPFRE_CENTER = '11',
  PRIVATE_CENTER = '10'
}

export interface MedicalSearch {
  searchType: 'LOCATION' | 'FACULTATIVE' | 'CENTER';
  isExtraSearch: boolean;
  product: string;
  speciality: string;
  subSpeciality: string;
  input?: string;
  facultativeName?: string;
  medicalCenterName?: string;
  productName?: string;
  specialityName?: string;
  subSpecialityName?: string;
  medicalGuideProduct?: string;
}

export interface MedicalCenter {
  key: string;
  name: string;
  phones: string[];
  address: Address;
  distance: number;
  latitude: string;
  longitude: string;
  type: MedicalType;
  specialities?: Speciality[];
}

export interface Product {
  id: string;
  name: string;
  medicalGuideCode?: string;
  specialities?: Speciality[];
}

export interface Speciality {
  id: string;
  name: string;
  specialists?: string[];
  subspecialities?: SubSpeciality[];
}

export interface SubSpeciality {
  id: string;
  name: string;
  specialist?: string;
}
